import { useState } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { Direction } from '@/api';

import TransactionAlertsHowItWorksModal from '../TransactionAlertsHowItWorksModal/TransactionAlertsHowItWorksModal';
import styles from './TransactionAlertsDataTabs.module.sass';

interface TransactionAlertsDataTabsProps {
  activeTab: Direction;
  onTabChange: (key: Direction) => void;
}

const TransactionAlertsDataTabs = ({
  activeTab,
  onTabChange,
}: TransactionAlertsDataTabsProps) => {
  const { t } = useTranslation();
  const [isHowItWorksModalOpen, setIsHowItWorksModalOpen] = useState(false);

  const tabs: TabsProps['items'] = [
    {
      key: 'income',
      label: <span className={styles.tab}>{t('translation.deposit')} ↓</span>,
    },
    {
      key: 'outcome',
      label: (
        <span className={styles.tab}>{t('translation.withdrawal')} ↑</span>
      ),
    },
  ];

  return (
    <>
      <div className={styles.nav}>
        <Tabs
          defaultActiveKey={tabs[0].key}
          activeKey={activeTab}
          type="card"
          size="middle"
          items={tabs}
          tabBarGutter={0}
          animated={false}
          className={styles.tabs}
          onChange={(key) => onTabChange(key as Direction)}
        />

        <button
          type="button"
          className={styles.howItWorks}
          onClick={() => setIsHowItWorksModalOpen(true)}
        >
          {t('translation.how_it_works')}
        </button>
      </div>

      <TransactionAlertsHowItWorksModal
        isOpen={isHowItWorksModalOpen}
        onClose={() => setIsHowItWorksModalOpen(false)}
      />
    </>
  );
};

export default TransactionAlertsDataTabs;
